import { UseLazyApiCallSimulation } from "hooks/use-lazy-api-call-simulation";
import { DownloadThreeD, DownloadTwoD, DownloadVideo } from "../iconComponents";

import { UseApiCallSimulation } from "hooks/use-api-call-simulation";
import { TracerColorIcon } from "../iconComponents/tracerColorIcon";
import { useCurrentUserContext } from "providers";
export const useGetInitialData = ({ fileid }) => {
  const { user } = useCurrentUserContext();
  const [download2DFunction] = UseLazyApiCallSimulation({
    url: "/download_2d_baseball",
    method: "POST",
    paramsData: {
      fileid,
    },
  });
  const [downloadVideoFunction] = UseLazyApiCallSimulation({
    url: "/download_video_baseball",
    method: "POST",
    paramsData: {
      fileid,
    },
  });

  // const {
  //   data: videoAllData,
  //   isLoading: videoAllDataLoading,
  //   error: videoAllDataError,
  // } = UseApiCallSimulation({
  //   url: "/baseball_results",
  //   method: "POST",
  //   paramsData: {
  //     fileid,
  //   },
  // });

  const downloadBtns = [
    {
      key: "videoIcon",
      icon: DownloadVideo,
      title: "Video",
      functionForApiCall: downloadVideoFunction,
    },
    {
      key: "twodIcon",
      icon: DownloadTwoD,
      title: "2D JSON",
      functionForApiCall: download2DFunction,
    },
    {
      key: "threedIcon",
      icon: DownloadThreeD,
      title: "3D JSON",
      functionForApiCall: download2DFunction,
    },
  ];

  return {
    downloadBtns,
    // videoAllData,
    // videoAllDataLoading,
    // videoAllDataError,
  };
};
